<template>
  <div
    class="bb-notifications-bar-main-pointer"
    :class="[readStatus !== item.readStatus && 'bb-notifications-bar-main-pointer_no-read']"
    @click="onReadNotification()"
    @mouseenter="onMouseenter($event)"
    @mouseleave="isShowPopup = false"
  >
    <div
      class="bb-notifications-bar-main-pointer__item"
      :class="[readStatus === item.readStatus && 'bb-notifications-bar-main-pointer__item_read']"
    />
    <transition name="bounce">
      <div
        v-if="isShowPopup"
        class="bb-notifications-bar-main-pointer-popup"
        :style="positionPopup"
      >
        Mark as read
      </div>
    </transition>
  </div>
</template>

<script>
import { HR_NOTIFICATION_RAED_STATUS_ID, HR_NOTIFICATION_NO_RAED_STATUS_ID } from '@/constants/hrNotificationReadStatus'

export default {
  name: 'NotificationsBarMainPointer',
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    readStatus: HR_NOTIFICATION_RAED_STATUS_ID,
    isShowPopup: false,
    positionPopup: {}
  }),
  methods: {
    onReadNotification () {
      this.$emit('onReadNotification', this.item)
    },
    onMouseenter ({target}) {
      const { readStatus } = this.item
      if (HR_NOTIFICATION_NO_RAED_STATUS_ID === readStatus) return
      this.isShowPopup = true
      const {top, left, height} = target.getBoundingClientRect()
      this.positionPopup = {
        top: `${top + height}px`,
        left: `${left - 25}px`
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../../sass/variables";

  .bb-notifications-bar-main-pointer {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 24px;
    left: 0;
    transition: 0.3s;
    opacity: 0;
    width: 22px;
    height: 22px;
    cursor: pointer;

    &__item {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: $color-denim;

      &_read {
        background: $color-silver;
      }
    }

    &_no-read {
      opacity: 1;
    }
  }

  .bb-notifications-bar-main-pointer-popup {
    position: fixed;
    width: max-content;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px 5px 4px 5px;
    background: rgba($color-black, 0.55);
    font-weight: 500;
    font-size: 11px;
    line-height: 13px;
    text-align: center;
    color: $color-white;
    border-radius: 3px;
    z-index: 20;
    pointer-events: none;

    &:before {
      content: '';
      position: absolute;
      left: auto;
      top: -3px;
      display: block;
      width: 0;
      height: 0;
      border-left: 3px solid transparent;
      border-right: 3px solid transparent;
      border-bottom: 3px solid rgba($color-black, 0.55);;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Notifications/NotificationsBar/NotificationsBarMainPointer.vue